export default "__VITE_ASSET__D_Da7njO__"